export default {
  "root": "_root_1i336_1",
  "--type-literal": "_--type-literal_1i336_1",
  "--type-unit": "_--type-unit_1i336_1",
  "--type-literal--m": "_--type-literal--m_1i336_1",
  "--type-unit--m": "_--type-unit--m_1i336_1",
  "--type-literal--l": "_--type-literal--l_1i336_1",
  "--type-unit--l": "_--type-unit--l_1i336_1",
  "--type-literal--xl": "_--type-literal--xl_1i336_1",
  "--type-unit--xl": "_--type-unit--xl_1i336_1"
};import "ni:sha-256;rrSbpf6B_SmIlh_lPELBDHT7whf-ustVtwAyau1z1HY";